import {Injectable} from '@angular/core';
import {EvkHttpService, EvkUpdateServiceBase} from '@evomatik/evk-common';
import {Observable} from 'rxjs';
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Injectable({
    providedIn: 'root'
})
export class CancelarDiligenciaService extends EvkUpdateServiceBase<DiligenciaTareaModel> {

    constructor(
        http: EvkHttpService
    ) {
        super(http);
    }

    evkOnBeforeEdit(data: DiligenciaTareaModel): Observable<DiligenciaTareaModel> {
        return new Observable(
            (observer) => {
                observer.next(data);
            }
        );
    }

    evkOnDoneEdit(data) {
    }

    public evkOnErrorEdit(error: any): void {
    }

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/cancelar';
    }
}
